<div class="p-4 md:p-6">
  <div class="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-4">
    <div>
      <h1 class="text-xl font-bold text-gray-900">Acquisition</h1>
      <p class="text-sm text-gray-500">How marketing turns into customers and pickups, across WhatsApp, web and organic channels. Dates are IST days.</p>
    </div>
    <div class="flex flex-wrap items-end gap-3 bg-white rounded-lg border border-gray-200 p-3">
      <div>
        <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">From</label>
        <app-date-input [(ngModel)]="fromDate"></app-date-input>
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">To</label>
        <app-date-input [(ngModel)]="toDate"></app-date-input>
      </div>
      <button (click)="applyRange()"
        class="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-4 py-2 rounded-md">
        <i class="fas fa-search mr-1"></i> Apply
      </button>
    </div>
  </div>

  <div *ngIf="rangeError" class="bg-red-50 text-red-700 border border-red-200 rounded-md px-4 py-3 mb-4 text-sm">
    <i class="fas fa-exclamation-circle mr-1"></i> {{ rangeError }}
  </div>

  <!-- Tabs -->
  <div class="border-b border-gray-200 mb-4 flex gap-1 overflow-x-auto" role="tablist">
    <button *ngFor="let tab of tabs" type="button" role="tab"
      [attr.aria-selected]="activeTab === tab.id"
      (click)="selectTab(tab.id)"
      class="px-4 py-2 text-sm font-semibold border-b-2 -mb-px whitespace-nowrap"
      [class.border-green-600]="activeTab === tab.id" [class.text-green-700]="activeTab === tab.id"
      [class.border-transparent]="activeTab !== tab.id" [class.text-gray-500]="activeTab !== tab.id">
      <i [class]="tab.icon + ' mr-1'"></i> {{ tab.label }}
    </button>
  </div>

  <div *ngIf="!appliedRanges[activeTab]"
    class="bg-white border border-dashed border-gray-300 rounded-lg px-4 py-10 text-center text-sm text-gray-500">
    <i class="fas fa-search mr-1"></i> Choose a date range and click <span class="font-semibold">Apply</span> to load this report.
  </div>

  <div *ngIf="staleRange" class="bg-amber-50 text-amber-800 border border-amber-200 rounded-md px-4 py-2 mb-4 text-sm">
    <i class="fas fa-info-circle mr-1"></i> Showing {{ staleRange.from }} to {{ staleRange.to }}. Click Apply to load the selected dates.
  </div>

  <!-- Each tab is created on its first Apply and then hidden, not destroyed, so switching tabs doesn't re-query. -->
  <app-acquisition-funnel *ngIf="appliedRanges['funnel'] as range" [hidden]="activeTab !== 'funnel'" [range]="range"></app-acquisition-funnel>
  <app-ad-leaderboard *ngIf="appliedRanges['ad-leaderboard'] as range" [hidden]="activeTab !== 'ad-leaderboard'" [range]="range"></app-ad-leaderboard>
  <app-cta-comparison *ngIf="appliedRanges['cta-comparison'] as range" [hidden]="activeTab !== 'cta-comparison'" [range]="range"></app-cta-comparison>
  <app-acquisition-retention *ngIf="appliedRanges['retention'] as range" [hidden]="activeTab !== 'retention'" [range]="range"></app-acquisition-retention>
  <app-acquisition-ltv *ngIf="appliedRanges['ltv'] as range" [hidden]="activeTab !== 'ltv'" [range]="range"></app-acquisition-ltv>
  <app-capi-health *ngIf="appliedRanges['capi-health'] as range" [hidden]="activeTab !== 'capi-health'" [range]="range"></app-capi-health>
</div>
